import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Logo from "@/components/Logo";
import { useI18n } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { fmtErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { t } = useI18n();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const davet = params.get("davet");
  const [form, setForm] = useState({ name: "", company: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await register(form);
      navigate(davet ? `/davet/${davet}` : "/app");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid-bg flex min-h-screen items-center justify-center bg-[#FDFDFD] px-5 py-16">
      <div className="w-full max-w-md">
        <div className="flex justify-center"><Link to="/" data-testid="register-logo-link"><Logo /></Link></div>
        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          <h1 className="font-display text-2xl font-medium tracking-tight text-slate-900">{t.auth.registerTitle}</h1>
          <p className="mt-1.5 text-sm text-slate-500">{t.auth.registerSub}</p>
          <form onSubmit={submit} className="mt-7 space-y-5" data-testid="register-form">
            <div className="space-y-2">
              <Label htmlFor="name">{t.auth.name}</Label>
              <Input id="name" required data-testid="register-name-input" value={form.name} onChange={set("name")} />
            </div>
            <div className="space-y-2">
              <Label htmlFor="company">{t.auth.company}</Label>
              <Input id="company" data-testid="register-company-input" value={form.company} onChange={set("company")} />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email">{t.auth.email}</Label>
              <Input id="email" type="email" required autoComplete="email" data-testid="register-email-input" value={form.email} onChange={set("email")} />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">{t.auth.password}</Label>
              <Input id="password" type="password" required minLength={6} autoComplete="new-password" data-testid="register-password-input" value={form.password} onChange={set("password")} />
            </div>
            {error && (
              <p className="rounded-md border border-red-100 bg-red-50 px-3.5 py-2.5 text-sm text-red-600" data-testid="register-error">
                {error}
              </p>
            )}
            <Button type="submit" disabled={busy} data-testid="register-submit-button" className="w-full">
              {busy ? t.auth.working : t.auth.register}
            </Button>
          </form>
          <p className="mt-6 border-t border-slate-100 pt-5 text-center text-xs text-slate-500">
            {t.auth.haveAccount}{" "}
            <Link to={davet ? `/giris?davet=${davet}` : "/giris"} data-testid="register-to-login-link" className="font-medium text-slate-900 hover:underline">{t.auth.toLogin}</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
